// src/WebSocketReconnectModal.js
import React from 'react';
import './WebSocketReconnectModal.css';

const WebSocketReconnectModal = ({ connectionStatus, onReconnect }) => {
  // Only show the modal if disconnected or in an error state
  const isVisible = connectionStatus === 'Disconnected' || connectionStatus === 'Connection Error';

  if (!isVisible) {
    return null; // Don't render anything if connected or connecting
  }

  return (
    <div className="modal-overlay">
      <div className="modal-dialog">
        <h2>WebSocket Disconnected</h2>
        <p>The connection to real-time updates has been lost.</p>
        <p>Current Status: <span className={`modal-status-${connectionStatus.toLowerCase().replace(/\s+/g, '-')}`}>{connectionStatus}</span></p>
        <button className="modal-reconnect-button" onClick={onReconnect}>
          Attempt Reconnect
        </button>
      </div>
    </div>
  );
};

export default WebSocketReconnectModal;